document.addEventListener('DOMContentLoaded', function() {
  zapietSeeMore();
  zapietAutoExpandOnFirstCartOpen();
  initCartIntercept();
});

function zapietSeeMore() {
  const sidebarCart = document.getElementById('sidebar-cart');
  if (!sidebarCart) return;

  sidebarCart.addEventListener('click', function(event) {
    const SeeMore = event.target.closest('.wim_zapiet_see_more');
    if (SeeMore) {
      SeeMore.classList.toggle('is-expanded');
    }
  });
}


function zapietAutoExpandOnFirstCartOpen() {
  const cartButton = document.querySelector('.Header__Wrapper a.cart-button');
  if (!cartButton) return;

  function handleFirstClick() {
    const pickupLabel = document.querySelector('label#pickup_radio');
    const pickupInput = pickupLabel ? pickupLabel.querySelector('input') : null;
    const SeeMore = document.querySelector('.wim_zapiet_see_more');

    if (SeeMore && pickupLabel && pickupInput) {

      if (pickupInput.checked) {
        SeeMore.classList.add('is-expanded');
        cartButton.removeEventListener('click', handleFirstClick);
      } else {

        SeeMore.classList.add('is-expanded');
        cartButton.removeEventListener('click', handleFirstClick);
      }
    } 
    
  }

  cartButton.addEventListener('click', handleFirstClick);

  const sidebarCart = document.getElementById('sidebar-cart');

  if (sidebarCart) {
    sidebarCart.addEventListener('click', function(event) {
      const clickedPickup = event.target.closest('#pickup_radio');
      if (!clickedPickup) return;

      const SeeMore = document.querySelector('.wim_zapiet_see_more');
      if (!SeeMore) return;

      if (!SeeMore.classList.contains('is-expanded')) {
        SeeMore.classList.add('is-expanded');
      }
    });

    sidebarCart.addEventListener('transitionend', function(e) {
      if (e.propertyName === 'opacity') {

        const errorEl = sidebarCart.querySelector('#storePickupApp p.error');

        if (errorEl) {
          const SeeMore = document.querySelector('.wim_zapiet_see_more');
          if(!SeeMore) return;

          if (!SeeMore.classList.contains('is-expanded')) {
            SeeMore.classList.add('is-expanded');
          }
        }
      }
    });
  }

if (!window.ZapietEvent || typeof window.ZapietEvent.listen !== 'function') return;
  window.ZapietEvent.listen('selected_method', function(checkout_method) {   
  switch (checkout_method) {
    case "delivery":
      // console.log("delivery");
      break;
    case "pickup":
      const SeeMore = document.querySelector('.wim_zapiet_see_more');

        if (!SeeMore.classList.contains('is-expanded')) {
          SeeMore.classList.add('is-expanded');
        }
      break;
  }
});
}

function initCartIntercept() {
  document.addEventListener('click', function(e) {
    var buyButton = e.target.closest('button[data-action="add-to-cart"], .ProductForm__AddToCart');
    
    if (!buyButton || buyButton.classList.contains('Buy--To-Checkout-button')) return;

    var form = buyButton.closest('form[action^="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var productContainer = buyButton.closest('.Product, .product-section, [data-section-type="product"]');
    var selectedRadio = productContainer ? productContainer.querySelector('input.ColorSwatch__Radio:checked') : null;
    var selectedSelector = productContainer ? productContainer.querySelector('select[name="id"]') : null;
    var variantId = null;

    if (selectedSelector) {
        variantId = selectedSelector.value;
    } else if (selectedRadio) {
        variantId = selectedRadio.getAttribute('data-variant-id');
    }

    if (!variantId) {
        var hiddenInput = form.querySelector('input[name="id"]');
        variantId = hiddenInput ? hiddenInput.value : null;
    }
    
    var quantity = form.querySelector('input[name="quantity"]') ? form.querySelector('input[name="quantity"]').value : 1;

    var xhr = new XMLHttpRequest();
    xhr.open("POST", "/cart/add.js", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          
          var cartLink = document.querySelector('a[data-drawer-id="sidebar-cart"]');
          if (cartLink) {
            setTimeout(function() {
              cartLink.click();
            }, 100);
          }
        } else {
          console.error("Error al añadir al carrito:", xhr.responseText);
          form.submit();
        }
      }
    };

    var payload = JSON.stringify({
      "items": [{
        "id": parseInt(variantId),
        "quantity": parseInt(quantity)
      }]
    });

    xhr.send(payload);

  }, true);
}